import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import { FHEListingHeader } from 'data/components';

class DetailExpansionPanel extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        headerTitle: PropTypes.string.isRequired,
        headerSvg: PropTypes.object.isRequired
    };

    render() {
        const { classes, children, headerTitle, headerSvg } = this.props;
        return (
            <div className={classes.detailPanelContainer}>
                <FHEListingHeader title={headerTitle} svgimage={headerSvg} />
                <div className={classes.detailPanel}>{children}</div>
            </div>
        );
    }
}

const styles = () => ({
    detailPanelContainer: {
        marginTop: 10,
        marginBottom: 10
    },
    detailPanel: {
        marginTop: -7
    }
});

export default withStyles(styles, { withTheme: true })(DetailExpansionPanel);



// WEBPACK FOOTER //
// ./environments/fhepool/scenes/SDM17DEC/ProductModule/DetailExpansionPanel.js